export default __webpack_public_path__ + "static/media/lou.ca0097e8.png";